import React from 'react'
import { AccordionHeader } from '../../../../Components/Layout/Accordion'
import { ChallengeItem } from './skillsHelper'

type HeaderParams = {
  skillsChallenge: ChallengeItem
}

export const ChallengeAccordionHeader: React.FC<HeaderParams> = ({
  skillsChallenge,
}) => {
  return (
    <AccordionHeader
      imgUrl={''}
      label={skillsChallenge.name}
      subText={skillsChallenge.winner ? `Win: ${skillsChallenge.winner}` : ''}
      colorTheme="dark"
      size="large"
    />
  )
}
